import {Component, OnInit, signal} from '@angular/core';
import {CordovaService} from '../../cordova.service';
import {Router, RouterLink} from '@angular/router';
import {LocalStorage} from '../../storage.class';
import {User} from '../../classes/user.class';
import {CodaltComponent} from '../../codalt.component';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-management',
    templateUrl: './management.component.html',
    styleUrls: ['./management.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatRipple
    ]
})
export class ManagementComponent extends CodaltComponent implements OnInit {
    readonly user = signal<User>(null);

    constructor(private router: Router,
                private cordovaService: CordovaService) {
        super();
    }

    ngOnInit(): void {
        this.user.set(LocalStorage.getUser());

        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
    }

}
